/**
 * Admin views: used by administator to manage application
 * Path: `@/views/admin`
 */

import multiguard from "vue-router-multiguard"
import { requireStaff } from "@/utils/middleware"

const AdminSummary = () => import("@/views/admin/AdminSummary.vue")
const AdminTemplates = () => import("@/views/admin/AdminTemplates.vue")
const AdminValidation = () => import("@/views/admin/AdminValidation.vue")
const Analytics = () => import("@/views/admin/Analytics.vue")
const CompaniesPlans = () => import("@/views/admin/CompaniesPlans.vue")
const CompanyPlans = () => import("@/views/admin/CompanyPlans.vue")
const AdminActions = () => import("@/views/admin/AdminActions.vue")

const AdminDrawer = () => import("@/components/layouts/core/AdminDrawer.vue")

export default [
  {
    path: "/admin",
    name: "Admin",
    redirect: { name: "AdminSummary" }
  },
  {
    path: "/admin/summary",
    component: AdminSummary,
    name: "AdminSummary",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/companies/plans",
    component: CompaniesPlans,
    name: "CompaniesPlans",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/company/plans/:id",
    component: CompanyPlans,
    name: "CompanyPlans",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/admin/analytics",
    component: Analytics,
    name: "Analytics",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/admin/validations",
    component: AdminValidation,
    name: "AdminValidation",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/templates",
    component: AdminTemplates,
    name: "AdminTemplates",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  },
  {
    path: "/admin/actions",
    component: AdminActions,
    name: "AdminActions",
    beforeEnter: multiguard([requireStaff]),
    meta: {
      layout: "default",
      drawer: AdminDrawer
    }
  }
]
